<template>
  <div class="page">
    <template v-if="data.state == 0 || data.state == -1 || editing">
      <template v-if="!submited">
        <div class="w400">
          <a-steps :current="currentStep">
            <a-step title="基本信息"></a-step>
            <a-step title="项目详情"></a-step>
          </a-steps>
        </div>
        <transition name="slide-fade" mode="out-in">
          <template v-if="currentStep == 0">
            <div class="w1000 v-mt-lg">
              <div class="panel">
                <div class="panel-body">
                  <a-form-model class="form-sm" ref="form" :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 17 }">
                    <a-form-model-item :colon="false" v-if="data.state == -1">
                      <span slot="label"></span>
                      <a-alert class="v-mb-sm no-border" type="error">
                        <div slot="message">
                          <div class="font-md text-darkblue flex items-center">
                            <a-icon type="alert" class="v-mr-xs" />
                            此筹款申请已被驳回
                          </div>
                          <div class="flex v-mt-xs">
                            <span class="text-right text-grey">审核意见：</span>
                            <span class="col text-red" v-html="$utils.convertToHtml(data.checkOpinion)"></span>
                          </div>
                        </div>
                      </a-alert>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        项目名称
                      </span>
                      <a-input v-model="form.prjName" ref="prjName" placeholder="请填写项目名称" style="width: 100%" />
                      <div class="ant-form-explain text-grey">项目名称不超过9个汉字，如：星火教育公益计划</div>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        公开募捐备案编号
                      </span>
                      <a-input disabled v-model="form.raiseNo" ref="raiseNo" placeholder="公开募捐备案编号" style="width: 300px" />
                      <div class="ant-form-explain text-grey">慈善中国网站上的“公开募捐备案编号”</div>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        简介
                      </span>
                      <a-textarea :auto-size="{ minRows: 2 }" v-model="form.summary" ref="summary" placeholder="项目简介" :rows="2" style="width: 100%" />
                      <div class="ant-form-explain text-grey" style="margin-top: 1px">最多27个汉字，提炼项目要解决的核心问题，可以加入公益单位，例如：每4元一顿免费午餐，让山区孩子不再饿肚子</div>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        项目立项日期
                      </span>
                      <a-date-picker v-model="form.startDate" value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 140px" ref="startDate" />
                      <div class="ant-form-explain text-grey" style="margin-top: 1px">选择项目开始时间，会根据该时间计算项目已执行年限，并在捐款前冷静器中展示给用户</div>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        捐助领域
                      </span>
                      <a-radio-group class="full-width" v-model="form.prjMainType" button-style="solid">
                        <a-row :gutter="[6, 6]">
                          <a-col :span="4" v-for="item in prjTypes" :key="item.name">
                            <a-radio-button class="text-center" style="width: 100%" :value="item.name">{{ item.name }}</a-radio-button>
                          </a-col>
                        </a-row>
                      </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        具体分类
                      </span>
                      <a-radio-group class="full-width" v-model="form.prjSubType" button-style="solid">
                        <a-row :gutter="[6, 6]">
                          <a-col :span="4" v-for="item in subTypes" :key="item">
                            <a-radio-button class="text-center v-px-sm" style="width: 100%" :value="item">{{ item }}</a-radio-button>
                          </a-col>
                        </a-row>
                      </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        项目地点
                      </span>
                      <a-cascader change-on-select style="width: 300px" expand-trigger="hover" :show-search="{ cascaderFilter }" :options="districts" placeholder="请选择项目执行地点" v-model="form.districts" ref="districts" />
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        受助对象
                      </span>
                      <a-radio-group v-model="form.targets" button-style="solid">
                        <a-row :gutter="[6, 6]">
                          <a-col :span="4" v-for="item in targets" :key="item">
                            <a-radio-button class="text-center v-px-sm" style="width: 100%" :value="item">{{ item }}</a-radio-button>
                          </a-col>
                        </a-row>
                      </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        受助对象数量
                      </span>
                      <a-input type="number" v-model="form.targetCount" ref="targetCount" placeholder="受助对象数量" style="width: 300px;" />
                      <div class="ant-form-explain text-grey" style="margin-top: 1px">该项目计划帮助多少数量的受助对象，如计划帮助100个学生则填：100</div>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        救助类型
                      </span>
                      <a-radio-group v-model="form.targetType" button-style="solid">
                        <a-radio-button value="个案救助">个案救助</a-radio-button>
                        <a-radio-button value="群体救助">群体救助</a-radio-button>
                      </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                      <span slot="label">公益单位</span>
                      为 <a-input v-model="form.unitTarget" placeholder="受助对象，如“贫困学生”" style="width: 200px" /> 捐出1 <a-input v-model="form.unit" placeholder="量词，如“份”" style="width: 110px" />
                      <a-input v-model="form.unitText" placeholder="公益单位，如“爱心午餐”" style="width: 200px" />，需要爱心用户捐赠 <a-input placeholder="捐赠金额" v-model="form.unitAmount" style="width: 100px" /> 元
                      <div class="ant-form-explain text-grey" style="margin-top: 1px">示例：为贫困学生捐出1份爱心午餐，需爱心用户捐赠5元</div>
                    </a-form-model-item>
                    <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                      <span slot="label">默认捐赠金额</span>
                      <div class="flex items-center">
                        <div style="width: 130px">乐捐（单次捐）</div>
                        <a-space>
                          <div class="input-wrapper">
                            <a-input-number v-model="form.singleAmount1" ref="singleAmount1" placeholder="默认20" class="no-handler" :formatter="value => $utils.numInputFormatter(value)" :parser="value => value.replace(/\$\s?|(,*)/g, '')" allow-clear style="width: 120px" />
                            <span class="input-unit">元</span>
                          </div>
                          <div class="input-wrapper">
                            <a-input-number v-model="form.singleAmount2" ref="singleAmount2" placeholder="默认50" class="no-handler" :formatter="value => $utils.numInputFormatter(value)" :parser="value => value.replace(/\$\s?|(,*)/g, '')" allow-clear style="width: 120px" />
                            <span class="input-unit">元</span>
                          </div>
                          <div class="input-wrapper">
                            <a-input-number v-model="form.singleAmount3" ref="singleAmount3" placeholder="默认100" class="no-handler" :formatter="value => $utils.numInputFormatter(value)" :parser="value => value.replace(/\$\s?|(,*)/g, '')" allow-clear style="width: 120px" />
                            <span class="input-unit">元</span>
                          </div>
                        </a-space>
                      </div>
                      <div class="flex items-center">
                        <div style="width: 130px">一起捐</div>
                        <a-space>
                          <div class="input-wrapper">
                            <a-input-number v-model="form.crowdAmount1" ref="crowdAmount1" placeholder="默认10" class="no-handler" :formatter="value => $utils.numInputFormatter(value)" :parser="value => value.replace(/\$\s?|(,*)/g, '')" allow-clear style="width: 120px" />
                            <span class="input-unit">元</span>
                          </div>
                          <div class="input-wrapper">
                            <a-input-number v-model="form.crowdAmount2" ref="crowdAmount2" placeholder="默认50" class="no-handler" :formatter="value => $utils.numInputFormatter(value)" :parser="value => value.replace(/\$\s?|(,*)/g, '')" allow-clear style="width: 120px" />
                            <span class="input-unit">元</span>
                          </div>
                          <div class="input-wrapper">
                            <a-input-number v-model="form.crowdAmount3" ref="crowdAmount3" placeholder="默认100" class="no-handler" :formatter="value => $utils.numInputFormatter(value)" :parser="value => value.replace(/\$\s?|(,*)/g, '')" allow-clear style="width: 120px" />
                            <span class="input-unit">元</span>
                          </div>
                        </a-space>
                      </div>
                      <div class="ant-form-explain text-grey" style="margin-top: 1px">此处填写捐款浮层中的默认捐款金额，需要填写3个，留空将使用系统默认金额</div>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        筹款时间
                      </span>
                      自项目上线之日起90个自然日
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        用户筹款目标
                      </span>
                      <div class="input-wrapper">
                        <a-input-number class="no-handler" placeholder="筹款金额" v-model="form.raiseAmount" :formatter="value => $utils.numInputFormatter(value)" :parser="value => value.replace(/\$\s?|(,*)/g, '')" :min="0" ref="raiseAmount" style="width: 200px" />
                        <span class="input-unit">元</span>
                      </div>
                      <div class="ant-form-explain text-grey" style="margin-top: 1px">用户筹款目标是指向公众筹款的目标,当用户筹款目标达到后，项目将停止筹款，请输入整数金额</div>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        项目筹款用途
                      </span>
                      <a-input v-model="form.usage" ref="usage" placeholder="筹款用途" style="width: 100%" />
                      <div class="ant-form-explain text-grey" style="margin-top: 1px">用于捐赠感谢卡的展示，向用户说明项目目的和目标，14个汉字，如：为贫困人群筹集3000份早餐</div>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">最低执行金额</span>
                      <div class="input-wrapper">
                        <a-input-number class="no-handler" placeholder="最低执行金额" v-model="form.limitAmount" :formatter="value => $utils.numInputFormatter(value)" :parser="value => value.replace(/\$\s?|(,*)/g, '')" :min="0" ref="limitAmount" style="width: 200px" />
                        <span class="input-unit">元</span>
                      </div>
                      <div class="ant-form-explain text-grey" style="margin-top: 1px">项目实施前必须筹集到的金额（若无论筹集到多少都可执行，可填0），还需在“项目预算”模块注明若最终所募少于“最低可执行金额”时善款的变更使用方向</div>
                    </a-form-model-item>
                  </a-form-model>
                </div>
              </div>
              <div class="text-center v-mt-sm v-mb-lg">
                <a-space>
                  <a-button icon="swap-right" type="primary" @click="handleNextStep">下一步，填写项目信息</a-button>
                  <a-button icon="close" type="default" @click="load" v-if="editing">取消编辑</a-button>
                  <a-button icon="undo" type="indigo" @click="handleReset" v-else>重置</a-button>
                </a-space>
              </div>
            </div>
          </template>
          <template v-else-if="currentStep == 1">
            <div class="w1100 v-mt-lg">
              <div class="panel">
                <div class="panel-body">
                  <a-form-model class="form-sm" ref="form" :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                    <a-form-model-item :colon="false" v-if="data.state == -1">
                      <span slot="label"></span>
                      <a-alert class="v-mb-sm no-border" type="error">
                        <div slot="message">
                          <div class="font-md text-darkblue flex items-center">
                            <a-icon type="alert" class="v-mr-xs" />
                            此筹款申请已被驳回
                          </div>
                          <div class="flex v-mt-xs">
                            <span class="text-right text-grey">审核意见：</span>
                            <span class="col text-red" v-html="$utils.convertToHtml(data.checkOpinion)"></span>
                          </div>
                        </div>
                      </a-alert>
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        项目详情
                      </span>
                      <tinymce id="myedit" ref="editor" v-model="form.content" :file-params="{ projectId, raiseId, fileType: 208, fileSign: 'PR' }" />
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        项目执行计划
                      </span>
                      <tinymce id="myedit" ref="editor" v-model="form.plan" :file-params="{ projectId, raiseId, fileType: 208, fileSign: 'PR' }" />
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        项目预算
                      </span>
                      <tinymce id="myedit" ref="editor" v-model="form.budgets" :file-params="{ projectId, raiseId, fileType: 208, fileSign: 'PR' }" />
                    </a-form-model-item>
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        剩余财产处置
                      </span>
                      <a-textarea :auto-size="{ minRows: 3 }" v-model="form.remains" ref="remains" placeholder="50字简要介绍公益项目，会显示在项目详情页的开头" :rows="2" style="width: 100%" />
                    </a-form-model-item>
                  </a-form-model>
                </div>
              </div>
              <div class="text-center v-mt-sm v-mb-lg">
                <a-space>
                  <a-button icon="swap-left" type="indigo" @click="currentStep = 0">返回上一步</a-button>
                  <a-button icon="check" type="primary" @click="handleConfirm" :loading="saving">提交筹款申请信息</a-button>
                  <a-button icon="close" type="default" @click="load" v-if="editing">取消编辑</a-button>
                  <!-- <a-button icon="undo" type="indigo" @click="handleReset">重置</a-button> -->
                </a-space>
              </div>
            </div>
          </template>
        </transition>
      </template>
      <template v-else>
        <a-result status="success" title="提交成功" sub-title="您填报的筹款申请信息已提交，请耐心等待审核结果。">
          <template #extra>
            <a-button key="view" type="primary" @click="load">查看已提交信息</a-button>
          </template>
        </a-result>
      </template>
    </template>
    <template v-else-if="[1, 2, 3].includes(data.state)">
      <div class="w960 v-mt-lg">
        <div class="panel">
          <div class="panel-body">
            <a-alert banner :show-icon="false" class="v-mb-sm" type="warning"  v-if="data.state == 1">
              <div slot="message" class="text-grey">此筹款申请于 {{ data.applyTime }} 提交，<a-button icon="form" type="indigo" size="small" @click="editing = true">重新编辑</a-button></div>
            </a-alert>
            <table class="table table-plain">
              <tbody>
                <tr>
                  <td colspan="4" class="text-indigo">基础信息</td>
                </tr>
                <tr>
                  <th width="180">项目名称</th>
                  <td width="35%">{{ form.prjName }}</td>
                  <th width="160">公开募捐备案编号</th>
                  <td>{{ form.raiseNo }}</td>
                </tr>
                <tr>
                  <th valign="top">项目简介</th>
                  <td colspan="3" v-html="$utils.convertToHtml(form.summary)"></td>
                </tr>
                <tr>
                  <th>项目立项日期</th>
                  <td>{{ form.startDate }}</td>
                  <th>捐助领域</th>
                  <td>{{ form.prjMainType }} — {{ form.prjSubType }}</td>
                </tr>
                <tr>
                  <th valign="top">项目地点</th>
                  <td>{{ form.districts ? form.districts.join('') : '' }}</td>
                  <th>救助类型</th>
                  <td>{{ form.targetType }}</td>
                </tr>
                <tr>
                  <th>受助对象</th>
                  <td>{{ form.targets }}</td>
                  <th>受助对象数量</th>
                  <td>{{ form.targetCount }}</td>
                </tr>
                <tr>
                  <th>公益单位</th>
                  <td colspan="3">每捐赠{{ form.unitAmount }}元，可为{{ form.unitTarget }}提供1{{ form.unit }}{{ form.unitText }}</td>
                </tr>
                <tr>
                  <th valign="top">默认捐赠金额</th>
                  <td colspan="3">
                    <div class="flex items-center">
                        <div style="width: 130px">乐捐（单次捐）</div>
                        <a-space>
                          <a-tag color="orange" class="">{{ $utils.thousands(form.singleAmount1 || 20, 1) }}元</a-tag>
                          <a-tag color="orange" class="">{{ $utils.thousands(form.singleAmount2 || 50, 1) }}元</a-tag>
                          <a-tag color="orange" class="">{{ $utils.thousands(form.singleAmount3 || 100, 1) }}元</a-tag>
                        </a-space>
                      </div>
                      <div class="flex items-center v-mt-sm">
                        <div style="width: 130px">一起捐</div>
                        <a-space>
                          <a-tag color="orange" class="">{{ $utils.thousands(form.crowdAmount1 || 10, 1) }}元</a-tag>
                          <a-tag color="orange" class="">{{ $utils.thousands(form.crowdAmount2 || 50, 1) }}元</a-tag>
                          <a-tag color="orange" class="">{{ $utils.thousands(form.crowdAmount3 || 100, 1) }}元</a-tag>
                        </a-space>
                      </div>
                  </td>
                </tr>
                <tr>
                  <th>用户筹款目标</th>
                  <td>{{ $utils.thousands(form.raiseAmount, 0) }} 元</td>
                  <th>最低执行金额</th>
                  <td>{{ $utils.thousands(form.limitAmount, 0) }} 元</td>
                </tr>
                <tr>
                  <td colspan="4" class="text-indigo">筹款信息</td>
                </tr>
                <tr>
                  <th valign="top">项目详情</th>
                  <td colspan="3" v-html="form.content"></td>
                </tr>
                <tr>
                  <th valign="top">项目执行计划</th>
                  <td colspan="3" v-html="form.plan"></td>
                </tr>
                <tr>
                  <th valign="top">项目预算</th>
                  <td colspan="3" v-html="form.budgets"></td>
                </tr>
                <tr>
                  <th valign="top">剩余财产处置</th>
                  <td colspan="3" v-html="form.remains"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import alldistricts from '@/utils/districts'
import tinymce from '@/components/tinymce'
import { submitRaise, getRaise } from '@/api/project/funded'
const prjTypes = [
  { name: '教育助学', children: ['素质教育', '艺术教育', '体育教育', '阅读推广', '安全教育', '视力保护', '助学金', '学习用品', '乡村支教', '特殊教育', '学前教育', '职业教育', '线上教育', '教学设备', '营养餐', '陪伴关爱', '生理卫生', '科创教育', '心理健康', '研学教育', '课程开发', '校园净水', '牙病防治', '生活用品', '师资培育', '校园安全', '防校园霸凌', '防性侵', '校园改造', '家庭教育', '教师资助'] },
  { name: '乡村振兴', children: ['产业振兴', '医疗卫生', '扶困济困', '养老助老', '农村基建', '创业促进', '扶弱救孤', '妇女关爱', '残障帮扶', '社区发展', '邻里互助', '人才培育', '技能发展', '基础保障'] },
  { name: '医疗救助', children: ['白血病', '癌症', '肿瘤', '尿毒症', '尘肺病', '防艾抗艾', '免疫性疾病', '皮肤病', '早产儿', '先心病', '脑瘫', '唇腭裂', '听力障碍', '视力障碍', '罕见病', '渐冻症', '器官移植', '烧烫伤', '意外受伤', '地中海贫血', '胆道闭锁', '宫颈癌', '麻风', '脊柱侧弯', '康复治疗', '干预治疗', '舒缓治疗', '临终关怀', '患者关怀', '家属关怀', '预防筛查', '医疗保险', '科普宣教', '医疗科研', '医护培养', '其他'] },
  { name: '灾害救援', children: ['地震', '海啸', '水灾', '旱灾', '火灾', '台风', '雪灾', '泥石流', '滑坡', '爆炸', '心理干预', '灾后重建', '防灾减灾', '救援队伍保障', '公共卫生', '过渡安置', '灾害科普', '救援能力建设', '其他'] },
  { name: '自然保护', children: ['大气污染', '土壤污染', '垃圾废弃物', '种植绿化', '水源保护', '濒危物种', '流浪猫狗', '动物福利', '二手回收', '环保创新', '生态扶贫', '环保任务', '自然教育', '水体污染', '海洋保护', '湿地保护', '垃圾分类', '生计替代', '公益诉讼', '行业建设', '碳中和', '碳减排'] },
  { name: '关怀倡导', children: ['寻亲团员', '环卫工关怀', '儿童权益', '孤儿福利', '文物保护', '传统文化', '公益发展', '社区公益', '心里援助', '防拐卖', '防走失', '防家暴', '母婴关爱', '银龄关怀', '适老化改造', '科技助老', '信息无障碍', '无障碍设施', '融合教育', '融合就业', '老兵关怀', '烈士关怀', '退伍军人', '失独家庭关怀', '职业关爱', 'AED', '非遗', '古建保护', '公益人才', '国际援助', '好人好事'] },
]
const targets = ['孤儿/事实孤儿', '贫困妇女', '空巢/留守老人', '残障人士', '自闭症', '留守儿童', '第三世界', '义工志愿者', '抗战老兵', '性少数群体', '少数民族', '弱势群体', '走失儿童', '失独家庭', '困境儿童', '乡村孩子', '儿童', '贫困家庭', '流动儿童', '其他']
const form = {
  // 基本信息
  prjType: 1,
  prjName: '',
  raiseNo: '',
  summary: '',
  startDate: undefined,
  prjMainType: prjTypes[0].name,
  prjSubType: undefined,
  districts: [],
  targets: undefined,
  targetCount: undefined,
  targetType: '群体救助',
  unit: '',
  unitAmount: undefined,
  unitTarget: '',
  unitText: '',
  raiseAmount: undefined,
  usage: '',
  limitAmount: undefined,
  singleAmount1: undefined,
  singleAmount2: undefined,
  singleAmount3: undefined,
  crowdAmount1: undefined,
  crowdAmount2: undefined,
  crowdAmount3: undefined,
  // 项目详情
  content: '',
  plan: '',
  budgets: '',
  remains: '',
}
export default {
  props: {
    raiseId: {
      type: Number,
      required: true,
    },
  },
  components: {
    tinymce,
  },
  data() {
    return {
      projectId: undefined,
      // raiseId: null,
      currentStep: 0,
      submited: false,
      editing: false,
      saving: false,
      data: {},
      districts: alldistricts,
      form: {
        ...form,
      },
      prjTypes,
      targets,
      privacyFiles: [],
      mainFiles: [],
      topFiles: [],
      executeFiles: [],
      rewardFiles: [],
      planFiles: [],
      serviceFiles: [],
    }
  },
  computed: {
    subTypes: vm => prjTypes.find(d => d.name === vm.form.prjMainType).children,
  },
  watch: {
    'form.prjMainType'() {
      this.form.prjSubType = undefined
    },
  },
  methods: {
    load() {
      this.loading = true
      this.editing = false
      getRaise(this.raiseId).then(({ data }) => {
        if (data.success) {
          let result = data.result
          let { projectId, raiseInfo, raiseNo, files } = result
          this.form = { ...form, ...JSON.parse(raiseInfo || '{}') }
          if (raiseNo) {
            this.form.raiseNo = raiseNo
          }
          result.privacyFiles = files.filter(file => file.fileType === 501)
          result.mainFiles = files.filter(file => file.fileType === 502)
          result.topFiles = files.filter(file => file.fileType === 503)
          result.executeFiles = files.filter(file => file.fileType === 504)
          result.rewardFiles = files.filter(file => file.fileType === 505)
          this.data = result
          this.projectId = projectId
          this.privacyFiles = result.privacyFiles.map(file => ({
            uid: file.fileId,
            name: file.fileOriginName,
            status: 'done',
            fileSign: 'PR',
            belongId: file.raiseId,
            ...file,
            url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${file.raiseId}&fileSign=PR`,
          }))
          this.mainFiles = result.mainFiles.map(file => ({
            uid: file.fileId,
            name: file.fileOriginName,
            status: 'done',
            fileSign: 'PR',
            belongId: file.raiseId,
            ...file,
            url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${file.raiseId}&fileSign=PR`,
          }))
          this.topFiles = result.topFiles.map(file => ({
            uid: file.fileId,
            name: file.fileOriginName,
            status: 'done',
            fileSign: 'PR',
            belongId: file.raiseId,
            ...file,
            url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${file.raiseId}&fileSign=PR`,
          }))
          this.executeFiles = result.executeFiles.map(file => ({
            uid: file.fileId,
            name: file.fileOriginName,
            status: 'done',
            fileSign: 'PR',
            belongId: file.raiseId,
            ...file,
            url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${file.raiseId}&fileSign=PR`,
          }))
          this.rewardFiles = result.rewardFiles.map(file => ({
            uid: file.fileId,
            name: file.fileOriginName,
            status: 'done',
            fileSign: 'PR',
            belongId: file.raiseId,
            ...file,
            url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${file.raiseId}&fileSign=PR`,
          }))
          this.submited = false
        }
      })
    },
    handleNextStep() {
      let { prjName, summary, startDate, prjSubType, targets, targetCount, districts, raiseAmount, usage, } = this.form
      this.$message.destroy()
      if (prjName.trim() === '') {
        this.$message.warning('请输入项目名称')
        this.$refs.prjName.focus()
        return
      }
      if (summary.trim() === '') {
        this.$message.warning('请输入项目简介')
        this.$refs.summary.focus()
        return
      }
      if (!startDate) {
        this.$message.warning('请选择项目立项日期')
        this.$refs.startDate.focus()
        return
      }
      if (!prjSubType) {
        this.$message.warning('请选择捐助领域具体分类')
        return
      }
      if (districts.length === 0) {
        this.$message.warning('请选择项目地点')
        this.$refs.districts.focus()
        return
      }
      if (!targets) {
        this.$message.warning('请选择受助对象')
        // this.$refs.targets.focus()
        return
      }
      if (targetCount == void 0) {
        this.$message.warning('请输入受助对象数量')
        this.$refs.targetCount.focus()
        return
      }
      if (!raiseAmount) {
        this.$message.warning('请输入用户筹款目标金额')
        this.$refs.raiseAmount.focus()
        return
      }
      if (usage.trim() === '') {
        this.$message.warning('请输入项目筹款用途')
        this.$refs.usage.focus()
        return
      }
      this.currentStep += 1
    },
    handleConfirm() {
      let { content, plan, budgets, remains } = this.form
      // let { mainFiles, topFiles } = this
      this.$message.destroy()
      if (content.trim() === '') {
        this.$message.warning('请输入项目详情')
        return
      }
      if (plan.trim() === '') {
        this.$message.warning('请输入项目执行计划')
        return
      }
      if (budgets.trim() === '') {
        this.$message.warning('请输入项目预算')
        return
      }
      if (remains.trim() === '') {
        this.$message.warning('请输入剩余财产处置')
        this.$refs.remains.focus()
        return
      }
      this.$confirm({
        title: '确认提交筹款申请信息？',
        centered: true,
        onOk: () => {
          this.handleSubmit()
        },
      })
    },
    handleSubmit() {
      this.saving = true
      let { mainFiles, topFiles, executeFiles, rewardFiles, privacyFiles } = this
      let files = mainFiles
        .map(({ fileId }) => ({ fileId }))
        .concat(topFiles.map(({ fileId }) => ({ fileId })))
        .concat(executeFiles.map(({ fileId }) => ({ fileId })))
        .concat(rewardFiles.map(({ fileId }) => ({ fileId })))
        .concat(privacyFiles.map(({ fileId }) => ({ fileId })))
      let params = {
        files,
        raiseId: this.raiseId,
        raiseInfo: JSON.stringify(this.form),
        projectId: this.projectId,
      }
      this.$message.destroy()
      submitRaise(params).then(({ data }) => {
        this.saving = false
        if (data.success) {
          this.submited = true
          this.$emit('submit')
        } else {
          this.$message.warning(data.msg)
        }
      })
    },
    handleReset() {},
    handleUploadChange(info, count, ref) {
      if (ref && this.$refs[ref]) {
        this[ref] = this.handleUploadFile(info, count)
        this.$refs[ref].$el.classList.remove('uploader-empty')
      }
    },
  },
  created() {
    this.load()
  },
}
</script>
